@let control = getControl();

<div class="text-control-wrapper">
  <htx-text-field
    [ctrl]="ctrl()"
    [label]="label()"
    [placeholder]="placeholder()"
    [isPassword]="type() === 'password'"
    [required]="required()">
  </htx-text-field>

  @if (ctrl().invalid && (ctrl().touched || ctrl().dirty)) {
    <htx-error-field
      [control]="control"
      [errorMessages]="errorMessages()">
    </htx-error-field>
  }
</div>
